import { render, staticRenderFns } from "./SportsNicheIcon.vue?vue&type=template&id=3151d93d&scoped=true"
import script from "./SportsNicheIcon.vue?vue&type=script&lang=js"
export * from "./SportsNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3151d93d",
  null
  
)

export default component.exports